import { PlayerSummary } from '@inplay/models';

export enum PlayerType {
  NewPlayer = 'newPlayer',
  ExistingPlayer = 'existingPlayer',
}

export type PlayerCardProps = {
  style?: string;
  player: PlayerSummary;
  selectedPlayer?: PlayerSummary;
  onClick?: (player: PlayerSummary) => void;
};

export type SelectPlayerProps = {
  onClose: () => void;
  onProceed: (
    selectedPlayer:
      | PlayerSummary
      | { portraitImage: string; fullBodyImage: string },
    playerType: PlayerType,
  ) => void;
};

export type ExistingPlayerProps = {
  playerLoading: boolean;
  query: string;
  setQuery: (value: string) => void;
  filteredPlayers: PlayerSummary[];
  selectedPlayer?: PlayerSummary;
  setSelectedPlayer: (player: PlayerSummary) => void;
};

export type NewPlayerProps = {
  images: {
    portraitImage: string;
    fullBodyImage: string;
  };
  setImages: React.Dispatch<
    React.SetStateAction<{
      portraitImage: string;
      fullBodyImage: string;
    }>
  >;
};

export enum ImageType {
  Portrait = 'portraitImage',
  FullBody = 'fullBodyImage',
}

export enum DropdownMenuAction {
  Replace = 'replace',
  Delete = 'delete',
}
